<template>
  <button class="btnText is-arrow" @click="openModal">
    記入にあたっての留意事項
  </button>
  <ModalBase v-if="modalState.isShow" @close-modal="closeModal">
    <div class="inner">
      <p class="title">記入にあたっての留意事項</p>
      <div class="contents">
        <ol class="cautionList">
          <li>
            入力いただいた内容は、病院向け専用ページ内に連携される仕様となっております。
          </li>
          <li>
            氏名・大学名・連絡先などの情報は自動で情報連携されるため、記入いただく必要はございません。
          </li>
          <li>
            お申し込みいただいた後は、各病院のご担当者様からの連絡をお待ちください。もし一週間以上連絡がない場合は、お手数おかけしますが、マイナビRESIDENT運営事務局まで<button
              class="btnText"
              @click="moveToContact"
            >
              お問い合わせ</button
            >ください。
          </li>
          <li>
            記入いただいた内容は各病院のご担当者様が直接目にすることになります。なるべく簡潔な文章で、丁寧な言葉遣いを意識してご記入ください。
            <ul class="exampleList">
              <li>
                <p>
                  <span class="icon"
                    ><img src="~@/assets/icon/circle.svg" alt="まる" /> </span
                  >何卒よろしくお願いいたします。
                </p>
                <p>
                  <span class="icon"
                    ><img src="~@/assets/icon/cross.svg" alt="ばつ"/></span
                  >お願いします。
                </p>
              </li>
              <li>
                <p>
                  <span class="icon"
                    ><img src="~@/assets/icon/circle.svg" alt="まる" /> </span
                  >～の資料をいただきたく存じます。
                </p>
                <p>
                  <span class="icon"
                    ><img src="~@/assets/icon/cross.svg" alt="ばつ"/></span
                  >～の資料が欲しいです。
                </p>
              </li>
              <li>
                <p>
                  <span class="icon"
                    ><img src="~@/assets/icon/circle.svg" alt="まる" /> </span
                  >～を見学させていただきたく存じます。
                </p>
                <p>
                  <span class="icon"
                    ><img src="~@/assets/icon/cross.svg" alt="ばつ"/></span
                  >～を見学させてください。
                </p>
              </li>
            </ul>
          </li>
        </ol>
      </div>
    </div>
  </ModalBase>
</template>

<script lang="ts">
import { reactive } from 'vue'
import ModalBase from '@/components/genenral/ModalBase.vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
export default {
  name: 'ModalInputCaution',

  components: {
    ModalBase
  },
  setup() {
    const router = useRouter()
    const store = useStore()

    const modalState = reactive({
      isShow: false
    })

    const closeModal = () => {
      store.commit('unFixBody')
      modalState.isShow = false
    }
    const openModal = () => {
      modalState.isShow = true
    }
    const moveToContact = () => {
      store.commit('unFixBody')
      const url = router.resolve('/contact/input')
      window.open(url.href, '_blank')
    }

    return {
      modalState,
      closeModal,
      moveToContact,
      openModal
    }
  }
}
</script>
<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;
.inner {
  height: 100vh;
}
.contents {
  overflow-y: scroll;
  padding-bottom: 40px;
  height: calc(100% - 170px);
  @include mixins.media() {
    height: calc(100% - 320px);
    padding: 0 48px 40px;
  }
}
.title {
  padding-top: 60px;
  text-align: center;
  font-weight: 500;
  margin-bottom: 20px;
  font-size: 1.8rem;
  letter-spacing: 0.03em;
  @include mixins.media() {
    padding-top: 0;
    margin-bottom: 32px;
  }
}
.cautionList {
  display: grid;
  gap: 12px;
  counter-reset: num;
  line-height: 1.78;
  letter-spacing: 0;
  > li {
    padding-left: 1.5em;
    position: relative;
    counter-increment: num;
    &::before {
      position: absolute;
      content: counter(num) '.';
      left: 0;
      top: 0;
    }
  }
}
.exampleList {
  display: grid;
  gap: 10px;
  margin-top: 12px;
  p {
    display: flex;
  }
  > li {
    background-color: #f5f5f5;
    padding: 12px 16px;
    font-size: 1.2rem;
    display: grid;
    gap: 4px;
    .icon {
      display: inline-flex;
      align-items: center;
      height: 100%;
      margin-right: 8px;
    }
  }
  @include mixins.media() {
    margin-top: 20px;
  }
}
.btnText {
  color: var.$color-main-text;
  &.is-arrow {
    margin-top: 12px;
    text-align: right;
    width: 100%;
    &::after {
      content: '';
      display: inline-block;
      width: 8px;
      height: 8px;
      border-right: 2px solid var.$color-main;
      border-bottom: 2px solid var.$color-main;
      transform: rotate(-45deg) translateY(-1px);
      margin-left: 4px;
      transition: border-color 0.1s;
    }
  }
}
</style>
